<template>
  <div>
    <div v-for="image in images" :key="image._key">
      <Media :image="image">
        <slot v-bind:image="image"></slot>
      </Media>
    </div>
  </div>
</template>

<script>
import Media from '@/components/Media'

export default {
  name: 'MediaCollection',
  components: { Media },
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
div + div {
  margin-top: 1.75em;
}
/deep/ {
  figure.portrait,
  figure.square {
    width: 66.6%;
  }
}
</style>
